/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

const envMgmtRoleName = process.env.REACT_APP_ENV_MGMT_ROLE_NAME;

// The workspace scheduling feature flag. Read here rather than imported from base-raas-ui, because
// this package does not depend on that one; the flag reaches the React build the same way for both.
const enableWorkspaceScheduler = process.env.REACT_APP_ENABLE_WORKSPACE_SCHEDULER === 'true';

export { envMgmtRoleName, enableWorkspaceScheduler };
